
import React from 'react';
import { IntegrationApp, Language } from '../../types';
import { TRANSLATIONS, DIALECTS } from '../../constants';

interface IntegrationsSettingsProps {
  language: Language;
  selectedApp: IntegrationApp;
  updateAppConfig: (key: string, value: any) => void;
}

const IntegrationsSettings: React.FC<IntegrationsSettingsProps> = ({ language, selectedApp, updateAppConfig }) => {
  const t = TRANSLATIONS[language];

  return (
     <div className="bg-white dark:bg-[#1a1a20] p-6 lg:p-8 rounded-3xl border border-slate-200 dark:border-white/5 animate-in slide-in-from-right-4">
        <h3 className="text-lg font-black text-slate-800 dark:text-white mb-6 border-b border-slate-100 dark:border-white/5 pb-4">App Configuration</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
           <div className="space-y-3">
              <label className="text-xs font-bold text-slate-500">{t.dialect}</label>
              <select 
                 value={selectedApp.config.dialect}
                 onChange={(e) => updateAppConfig('dialect', e.target.value)}
                 className="w-full bg-slate-50 dark:bg-black/20 border border-slate-200 dark:border-white/10 rounded-xl px-4 py-3 text-sm font-bold dark:text-white outline-none"
              >
                 {DIALECTS.map(d => <option key={d.id} value={d.id}>{d.name[language]}</option>)}
              </select>
           </div>
           {/* Additional setting placeholders could go here */}
        </div>
     </div>
  );
};

export default IntegrationsSettings;
